module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    ref: "registerSettlementForm",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.submitSettlement($event)
      }
    }
  }, [_c('b-card', {
    attrs: {
      "header-text-variant": "dark"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('context-header', {
    attrs: {
      "title": "Измирење фактуре"
    }
  })], 1), _vm._v(" "), (_vm.showErrorContainer) ? _c('b-card', {
    staticClass: "m-1",
    attrs: {
      "no-body": "",
      "header-bg-variant": "danger",
      "header": _vm.$t('groupSettlement.massInputError.tableHeader'),
      "header-text-variant": "white"
    }
  }, [_c('div', {
    staticClass: "list-container"
  }, [_c('b-list-group', _vm._l((_vm.errorList), function(error) {
    return _c('b-list-group-item', {
      key: error
    }, [_vm._v(_vm._s(error.settlementError.description))])
  }), 1)], 1)]) : _vm._e(), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "id": "checkbox1"
    },
    model: {
      value: (_vm.settleByIdf),
      callback: function($$v) {
        _vm.settleByIdf = $$v
      },
      expression: "settleByIdf"
    }
  }, [_vm._v("\r\n            Измирење по идентификатору фактуре\r\n        ")]), _vm._v(" "), (_vm.settleByIdf) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Идентификатор фактуре"
    }
  }, [_c('b-form-input', {
    attrs: {
      "name": "invoiceSettlement.InvoiceId"
    },
    model: {
      value: (_vm.invoiceSettlement.InvoiceId),
      callback: function($$v) {
        _vm.$set(_vm.invoiceSettlement, "InvoiceId", $$v)
      },
      expression: "invoiceSettlement.InvoiceId"
    }
  })], 1)], 1)], 1) : _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Број фактуре"
    }
  }, [_c('b-form-input', {
    attrs: {
      "name": "invoiceSettlement.InvoiceNumber"
    },
    model: {
      value: (_vm.invoiceSettlement.InvoiceNumber),
      callback: function($$v) {
        _vm.$set(_vm.invoiceSettlement, "InvoiceNumber", $$v)
      },
      expression: "invoiceSettlement.InvoiceNumber"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "ЈБКЈС"
    }
  }, [_c('b-form-input', {
    attrs: {
      "name": "invoiceSettlement.DebtorCompanyNumber"
    },
    model: {
      value: (_vm.invoiceSettlement.DebtorCompanyNumber),
      callback: function($$v) {
        _vm.$set(_vm.invoiceSettlement, "DebtorCompanyNumber", $$v)
      },
      expression: "invoiceSettlement.DebtorCompanyNumber"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "МБ Повериоца"
    }
  }, [_c('b-form-input', {
    attrs: {
      "name": "invoiceSettlement.CreditorCompanyNumber",
      "maxlength": "8"
    },
    model: {
      value: (_vm.invoiceSettlement.CreditorCompanyNumber),
      callback: function($$v) {
        _vm.$set(_vm.invoiceSettlement, "CreditorCompanyNumber", $$v)
      },
      expression: "invoiceSettlement.CreditorCompanyNumber"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "ПИБ Повериоца"
    }
  }, [_c('b-form-input', {
    attrs: {
      "name": "invoiceSettlement.CreditorTaxIdNumber",
      "maxlength": "9"
    },
    model: {
      value: (_vm.invoiceSettlement.CreditorTaxIdNumber),
      callback: function($$v) {
        _vm.$set(_vm.invoiceSettlement, "CreditorTaxIdNumber", $$v)
      },
      expression: "invoiceSettlement.CreditorTaxIdNumber"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Банка"
    }
  }, [_c('b-form-input', {
    attrs: {
      "name": "invoiceSettlement.Bank",
      "maxlength": "3"
    },
    model: {
      value: (_vm.invoiceSettlement.Bank),
      callback: function($$v) {
        _vm.$set(_vm.invoiceSettlement, "Bank", $$v)
      },
      expression: "invoiceSettlement.Bank"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12",
      "md": "3",
      "lg": "3",
      "xl": "3"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Измирени износ"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": _vm.$t('invoices.invoiceCurrency')
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "name": "invoiceSettlement.SettledAmount"
    },
    model: {
      value: (_vm.invoiceSettlement.SettledAmount),
      callback: function($$v) {
        _vm.$set(_vm.invoiceSettlement, "SettledAmount", $$v)
      },
      expression: "invoiceSettlement.SettledAmount"
    }
  }, 'money', _vm.currency, false))], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('invoices.columnSettlementComments')
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceSettlement.SettlementComments),
      expression: "invoiceSettlement.SettlementComments"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "name": "invoiceSettlement.SettlementComments"
    },
    domProps: {
      "value": (_vm.invoiceSettlement.SettlementComments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invoiceSettlement, "SettlementComments", $event.target.value)
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "success",
      "disabled": _vm.load
    }
  }, [_vm._v("\r\n                Региструј измирење\r\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ccd56e18", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ccd56e18","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./src/components/home/settlement/settle-invoice.html
// module id = 805
// module chunks = 1